<template>
  <v-row
  >
    <v-col cols="3">
      <v-card tile min-height="100%" color="grey lighten-3" flat>
        <v-list color="grey lighten-3">
          <cmif-corresp-action-dates-and-places
            :ca="correspActions"
          ></cmif-corresp-action-dates-and-places>
          <cmif-corresp-action-dates-and-places
            :ca="correspActions"
            action-type="received"
          ></cmif-corresp-action-dates-and-places>
        </v-list>
      </v-card>
    </v-col>

    <v-col cols="9">
      <v-card tile min-height="100%" color="grey lighten-3" flat>
        <v-card-title class="pb-0">
          <cmif-corresp-action
            :ca="correspActions"
          ></cmif-corresp-action>
        </v-card-title>
        <v-card-text class="py-0">
          <cmif-corresp-source
            v-for="(edition, idx) in editions"
            :key="'edition' + idx"
            :bibl="edition"
          ></cmif-corresp-source>
          <p v-if="letterNumber">
            {{ $t('letter-no', [letterNumber]) }}
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CmifCorrespAction from '@/components/CmifCorrespAction'
import CmifCorrespActionDatesAndPlaces from '@/components/CmifCorrespActionDatesAndPlaces'
import CmifCorrespSource from '@/components/CmifCorrespSource'

export default {

  name: 'CmifCorrespDescription',

  props: {
    letterNumber: { type: String, default: null },
    correspActions: { type: Array, default: null },
    editions: { type: Array, default: null }
  },

  components: {
    CmifCorrespAction,
    CmifCorrespActionDatesAndPlaces,
    CmifCorrespSource
  },

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>
